// extracted by mini-css-extract-plugin
module.exports = {"content":"AffiliatesModel_content__7__76"};